<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%', overflow: 'auto' }">
    <div class="mb-10px text-right">
      <el-button size="small" type="primary">保存</el-button>
      <el-button size="small">取消</el-button>
      <el-button size="small" type="primary">执行</el-button>
    </div>
    <el-form label-position="left" label-width="110px">
      <div>
        <i class="iconfont icon-bg-play text-[#0082f7] text-18px"></i>
        基本信息
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="任务类型">
            <el-select size="small"></el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="任务名称">
            <el-input size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="任务描述">
            <el-input type="textarea" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="mb-10px">
        <i class="iconfont icon-bg-play text-[#0082f7] text-18px"></i>
        数据源选择
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="h-30px w-full bg-[#0082f7] text-[#fff] text-center leading-30px">
            <span>来源</span>
            <i class="mt-5px mr-5px text-18px float-right iconfont icon-line-right"></i>
          </div>
          <el-row :gutter="20" class="mt-10px">
            <el-col :span="8">
              <el-form-item label="数据源类型">
                <el-select placeholder="数据源类型" size="small"></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="数据源名称">
                <el-select placeholder="数据源名称" class="w-full" size="small"></el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="text-right mb-10px">
            <span class="text-14px text-[#5291dd]">新增数据源</span>
          </div>
          <el-form-item label="表">
            <el-select class="w-full" placeholder="表" size="small"></el-select>
          </el-form-item>
          <el-form-item label="唯一索引性字段">
            <el-select class="w-full" placeholder="唯一性字段选择" size="small"></el-select>
          </el-form-item>
          <el-form-item label="过滤条件">
            <el-input type="textarea" placeholder="请输入内容"></el-input>
          </el-form-item>
          <div class="text-right mb-10px">
            <span class="text-14px text-[#5291dd]">预览数据</span>
          </div>
          <div class="mb-10px">
            <i class="iconfont icon-bg-play text-[#0082f7] text-18px"></i>
            运行参数
          </div>
          <el-form-item label="最大并发数">
            <el-input size="small"></el-input>
          </el-form-item>
          <div class="mb-10px">
            <i class="iconfont icon-bg-play text-[#0082f7] text-18px"></i>
            调度设置
          </div>
          <el-form-item label="调度类型">
            <el-radio-group>
              <el-radio label="正常调度"></el-radio>
              <el-radio label="暂停调度"></el-radio>
              <el-radio label="空跑调度"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="任务生产方式">
            <el-radio-group>
              <el-radio label="T+1次日生产"></el-radio>
              <el-radio label="生效后立即生成"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Cron表达式">
            <div class="flex items-center">
              <el-input size="small"></el-input>
              <el-button class="ml-10px" @click="clickCron" type="primary">Cron设计器</el-button>
            </div>
          </el-form-item>
          <el-form-item label="超时设置">
            <div class="flex items-center">
              <el-radio-group class="w-400px">
                <el-radio label="系统默认"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <el-input placeholder="单位s"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="重跑设置">
            <el-select placeholder="重跑设置" class="w-full"></el-select>
          </el-form-item>
          <el-form-item label="任务生效时间">
            <el-date-picker
              class="!w-full"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="h-30px w-full bg-[#0082f7] text-[#fff] text-center leading-30px">
            <span>目标</span>
            <i class="mt-5px mr-5px text-18px float-right iconfont icon-line-right"></i>
          </div>
          <el-row :gutter="20" class="mt-10px">
            <el-col :span="8">
              <el-form-item label="数据源类型">
                <el-select placeholder="数据源类型" size="small"></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="数据源名称">
                <el-select placeholder="数据源名称" class="w-full" size="small"></el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="text-right mb-10px">
            <span class="text-14px text-[#5291dd]">新增数据源</span>
          </div>
          <el-form-item label="表">
            <el-select class="w-full" placeholder="表" size="small"></el-select>
          </el-form-item>
          <el-form-item label="分区设置">
            <el-input placeholder="请输入内容" size="small"></el-input>
          </el-form-item>
          <el-form-item label="写入模式">
            <el-select class="w-full" size="small"></el-select>
          </el-form-item>
          <el-form-item label="自定义参数">
            <el-input size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" title="Cron表达式设计">
      <cron ref="cron" class="h-full w-full"></cron>
      <span slot="footer">
        <el-button type="primary">保存</el-button>
        <el-button @click="cancelCron">取消</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import cron from '@/components/inferenceEngine/cron'

export default {
  components: {
    cron,
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    /**
     * @description 取消cron表达设计
     */
    cancelCron() {
      this.dialogVisible = false
    },

    /**
     * @description 点击cron设计
     */
    clickCron() {
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
